import { computed, onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import notify from '@/components/base-components/components/notification/notify.js';
import i18n from '@/plugins/i18n.ts';
import { instance as api } from '@/api/api.ts';

const defaultLoaderOptions = {
    opaque:        true,
    message:       i18n.t('fetching data'),
    socketMessage: undefined,
    showMessage:   true,
};

export default function usePageData({ fetcher, onFetchData, onFailData, onFinallyData, autoFetch = true }) {
    const loading = ref(autoFetch);
    const loaded = ref(false);
    const loaderOptions = ref({ ...defaultLoaderOptions });
    const loader = computed(() => ({
        show: loading.value,
        ...loaderOptions.value,
    }));

    function showLoader(options = {}) {
        loaderOptions.value = {
            ...defaultLoaderOptions,
            ...options,
        };
        loading.value = true;
    }

    function hideLoader() {
        loaderOptions.value = { ...defaultLoaderOptions };
        loading.value = false;
    }

    const route = useRoute();

    async function fetchData() {
        showLoader();

        try {
            const data = await (fetcher ? fetcher() : api.get(route.fullPath));

            await onFetchData?.(data);
        } catch (error) {
            if (!onFailData) {
                notify.error(i18n.t('tmp An error occurred'));
            } else {
                await onFailData?.(error);
            }
        } finally {
            hideLoader();
            loaded.value = true;

            await onFinallyData?.();
        }
    }

    onBeforeMount(async () => {
        if (!autoFetch) return;

        await fetchData();
    });

    return {
        loading,
        loaded,
        loader,

        fetchData,
    };
}
